import { Check } from 'lucide-react';

export type AvailabilityField = 'open_to_collaborate' | 'open_to_cpm';

type Props = {
    openToCollaborate: boolean;
    openToCpm: boolean;
    disabled: boolean;
    onChange: (field: AvailabilityField, nextOpen: boolean) => void;
};

const AvailabilityControls = ({ openToCollaborate, openToCpm, disabled, onChange }: Props) => (
    <div className="availability-options">
        <label className="checkbox-row">
            <input
                type="checkbox"
                checked={openToCollaborate}
                disabled={disabled}
                onChange={(event) => onChange('open_to_collaborate', event.target.checked)}
            />
            <span>
                <Check size={13} />
            </span>
            Open to collaborate
        </label>
        <label className="checkbox-row">
            <input
                type="checkbox"
                checked={openToCpm}
                disabled={disabled}
                onChange={(event) => onChange('open_to_cpm', event.target.checked)}
            />
            <span>
                <Check size={13} />
            </span>
            Open to CPM campaigns
        </label>
    </div>
);

export default AvailabilityControls;
